import { debounce, isEmpty } from "lodash";
import React, { useMemo, useState } from "react";
import { apiGet } from "../../Utils/apiFetch";
import { Link, useNavigate } from "react-router-dom";
import apiPath from "../../Utils/apiPath";
import moment from "moment";
const SearchWrapper = ({ search, setSearch }) => {
  const [input, setInput] = useState("");
  const [list, setList] = useState([]);
  function isDateToday(date) {
    return moment(date).isSame(moment(), "day");
  }
  const navigate = useNavigate();
  const debounceFn = useMemo(() => debounce(handleDebounceFn, 500), []);
  const getData = async (value) => {
    if (isEmpty(value)) {
      setList([]);
    } else {
      const { status, data } = await apiGet(apiPath.searchEvent, {
        keyword: value,
      });
      if (data?.success) {
        setList(data?.results);
      }
    }
  };
  function handleDebounceFn(inputValue) {
    getData(inputValue);
  }

  function handleChange(event) {
    setInput(event.target.value);
    debounceFn(event.target.value);
  }

  return (
    <div id="searchWrap" className="overlay" style={{ display: "block" }}>
      <div id="searchPop" className="search-pop">
        <form>
          <a
            onClick={(e) => {
              e.preventDefault();
              setSearch(false);
            }}
            id="searchBack"
            className="search-back ui-link"
            href="#"
          >
            Back
          </a>
          <input
            id="searchInput"
            className="search-input"
            data-role="none"
            type="text"
            autoCapitalize="off"
            autoComplete="off"
            autoCorrect="off"
            placeholder="Search Events"
            onChange={(e) => handleChange(e)}
            value={input}
          />
          <button
            onClick={() => {
              setInput("");
              setList([]);
            }}
            id="searchClear"
            className="search-clear ui-btn ui-shadow ui-corner-all"
            type="reset"
          >
            Reset
          </button>
          <button
            id="searchBtn"
            className="search-collapse ui-btn ui-shadow ui-corner-all"
          >
            Search
          </button>
        </form>
        <div id="searchResult" className="suggestion-wrap" style={{}}>
          {list?.length > 0 ? (
            <ul id="searchList" style={{ display: "block" }}>
              {list?.map((res) => {
                return (
                  <li
                    id="result_34733240_1_247800805"
                    style={{ display: "list-item" }}
                  >
                    <a className="ui-link">
                      <span id="marketTime" className="time">
                        {isDateToday(res?.eventDateTime)
                          ? moment(res?.eventDateTime).format("HH:MM")
                          : moment(res?.eventDateTime).format("DD/MM HH:MM")}
                      </span>
                      {res?.eventName}
                    </a>
                  </li>
                );
              })}
            </ul>
          ) : (
            <dl id="noMatching" className="no-matching">
              <dt />
              <dd>No events found matching ...</dd>
            </dl>
          )}
        </div>
      </div>
    </div>
  );
};

export default SearchWrapper;
